module.exports = __webpack_public_path__ + "img/this_chair.576c6eca.webp";